module.exports = __webpack_public_path__ + "static/media/login-facebook.52b77acf.svg";